module.exports = __webpack_public_path__ + "static/media/logo_2x.9b3b57fc.png";